import { HStack } from "@chakra-ui/react";
import { Avatar, Link } from "@components/ui-kit";
import { useInvoiceDetailStore } from "../../../store";

export const Brands = () => {
  const store = useInvoiceDetailStore();

  return (
    <HStack mb="4" spacing="10">
      {store.invoice?.brands.map((b) => (
        <Link
          key={b.id}
          href={{ pathname: "/brands/detail", query: { id: b.id } }}
          display="flex"
          alignItems="center"
        >
          <Avatar
            size="sm"
            name={b.name}
            src={b.image?.urls.thumbnail}
            pr="3"
          />
          <span>{b.name}</span>
        </Link>
      ))}
    </HStack>
  );
};
